import * as _ from 'lodash';
import * as Utility from './UtilityFunctions';

export function getTeamToUpdate(team, teamInfoObject) {
  team = _.cloneDeep(team);
  team.name = teamInfoObject.name;
  team.teamLeadIds =
    teamInfoObject.users && teamInfoObject.users.teamleads ? teamInfoObject.users.teamleads.map((item) => item.id) : [];
  team.teamMemberIds =
    teamInfoObject.users && teamInfoObject.users.teammembers
      ? teamInfoObject.users.teammembers.map((item) => item.id)
      : [];
  team.allowedTaskTypeCreateGroups = teamInfoObject.allowedTaskTypeCreateGroups;
  return team;
}

export function getUsersForteam(team) {
  let usersList = [];
  if (team.teamLeadIds) {
    usersList = usersList.concat(team.teamLeadIds);
  }
  usersList = usersList.concat(team.teamMemberIds);
  usersList = _.uniq(usersList);
  return usersList;
}

export function mapUsersToNewTeam(newTeam, { team, teamLeadsList, teamMembersList }) {
  const users = {};
  users.teamleads = []; // All Lowercase without space
  users.teammembers = [];
  const teamLeadsDict = _.keyBy(teamLeadsList, 'key');
  const teamMembersDict = _.keyBy(teamMembersList, 'key');
  team.teamLeadIds.forEach((id) => {
    const user = teamLeadsDict[id];
    if (user) {
      users.teamleads.push({
        id: user.key,
        firstName: user.first,
        lastName: user.last,
      });
    }
  });

  team.teamMemberIds.forEach((id) => {
    const user = teamMembersDict[id];
    if (user) {
      users.teammembers.push({
        id: user.key,
        firstName: user.first,
        lastName: user.last,
      });
    }
  });
  newTeam.users = users;
}

export function updateAddedDeletedUsers(teamId, state, existingTeam = {}) {
  const {
    teamLeadsList,
    team: { teamLeadIds, teamMemberIds },
  } = state;
  const { teamLeadIds: prevTeamLeadIds = [], teamMemberIds: prevteamMemberIds = [] } = existingTeam;
  const usersListwithTeams = teamLeadsList;
  const usersDictWithTeams = _.keyBy(usersListwithTeams, 'key');
  const updatedUser = [];
  const deletedUser = [];
  const {
    added: addedTeamLeads = [],
    deleted: deletedTeamLeads = [],
    unchanged: unchangedTeamLeads = [],
  } = Utility.getMappedEntityChanges(teamLeadIds, prevTeamLeadIds);
  const {
    added: addedTeamMembers = [],
    deleted: deletedTeamMembers = [],
    unchanged: unchangedTeamMembers = [],
  } = Utility.getMappedEntityChanges(teamMemberIds, prevteamMemberIds);
  const usersList = _.union(addedTeamLeads, deletedTeamLeads, addedTeamMembers, deletedTeamMembers);

  usersList.forEach((id) => {
    const deviceMetadata = Utility.parseJSONStringToObject(usersDictWithTeams[id]?.originalObject?.deviceMetadata);
    const oldTeams = usersDictWithTeams[id].teams;
    const oldTeamsDict = _.keyBy(oldTeams, 'teamId');
    let reqTeam = oldTeamsDict[teamId] || { teamId };
    reqTeam = { ...reqTeam, isDeleted: false };
    reqTeam.isTeamLead = addedTeamLeads.includes(id) || unchangedTeamLeads.includes(id);
    reqTeam.isTeamMember = addedTeamMembers.includes(id) || unchangedTeamMembers.includes(id);
    if (reqTeam.isTeamLead === false && reqTeam.isTeamMember === false) {
      reqTeam.isDeleted = true;
      deletedUser.push(id);
    }
    oldTeamsDict[teamId] = reqTeam;
    const newTeamsList = Object.values(oldTeamsDict);

    usersDictWithTeams[id].teams = newTeamsList;
    const updateUserObject = {
      id,
      teams: newTeamsList,
      // JSON stringify as mutation reires AWSJSON
      deviceMetadata: JSON.stringify(deviceMetadata || {}),
    };
    updatedUser.push(updateUserObject);
  });
  return { updatedUser, deletedUser };
}

export function getUpdatedAreas(userIDs, teamId, areas = []) {
  const updatedAreas = [];
  areas.forEach((area) => {
    let isAreaUpdated = false;
    area.teams = area.teams || [];
    const teams = area.teams.filter((team) => team.teamId === teamId);
    const reqTeam = teams[0];
    reqTeam.resources = reqTeam.resources || [];
    const filteredResources = reqTeam.resources.filter((resource) => userIDs.indexOf(resource.userId) === -1);
    if (filteredResources.length !== reqTeam.resources.length) {
      // if userId does exist in this area
      reqTeam.resources = filteredResources;
      isAreaUpdated = true;
    }
    if (isAreaUpdated) {
      const areaObj = { id: area.id, teams: area.teams };
      updatedAreas.push(areaObj);
    }
  });
  return updatedAreas;
}
